import { useNavigate } from 'react-router-dom';
import { HelpTip, SignInFlow } from '@dataroom/shared';

/** Seller sign-in: password or emailed code (an invited seller sets a password). */
export function LoginPage() {
  const navigate = useNavigate();
  return (
    <SignInFlow
      title="Seller Submission"
      subtitle="Sign in to submit documents to the data room."
      startSlot={
        <p className="flex items-center gap-1 text-sm text-muted-foreground">
          First time here, or no password yet? <HelpTip id="seller.login.email-code" />
        </p>
      }
      onSignedIn={() => navigate('/')}
    />
  );
}
